import { CSSProperties } from "react";

const cardPadding = 10;

export const container: CSSProperties = {};

export const actions: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  paddingBottom: cardPadding,
  paddingLeft: cardPadding,
  paddingRight: cardPadding,
};

export const button: CSSProperties = {
  flexGrow: 1,
};

export function getCardHeader(bgImg: string, bgColor: string): CSSProperties {
  return {
    background: `${bgColor} url(${bgImg}) center / 100px no-repeat`,
    width: "100%",
    height: 120,
    padding: cardPadding,
  };
}

export const cardContent: CSSProperties = {
  paddingTop: cardPadding,
  paddingLeft: cardPadding,
  paddingRight: cardPadding,
};

export const h5: CSSProperties = {
  paddingBottom: 0,
};

export const p: CSSProperties = {
  fontSize: 14,
  lineHeight: 1.4,
  marginBottom: cardPadding,
};
